import { request } from "./client";
import type { OpenSessionsResponse } from "./types";

/** GET /api/v1/tawa/sessions/open — currently open work/break/activity sessions for the tenant. */
export async function listOpenSessions(): Promise<OpenSessionsResponse> {
  return request<OpenSessionsResponse>({
    method: "GET",
    url: "/sessions/open",
  });
}
